import basicController from 'servicestack/basic.controller.properties'
import Product from 'emun.shopping/product.model'
import AutoQuery from 'servicestack/auto-query/auto-query'
import ServiceBus from 'servicestack/service-bus'
import modals from 'webmodals/modals'
import $appConfig from 'servicestack/config'
import ReturnItemPrompt from 'emun.invoice/return-item-prompt'
import creditMemoPrompt from 'emun.invoice/credit-memo-prompt'
import mediaManagerPrompt from 'webutils/media/media-manager-prompt'
import config from 'emun.invoice/invoice.config'
import _ from 'underscore'

export default class CreditMemoEditController {
  constructor() {
    const $ctrl = this;
    basicController(this)
    $ctrl.bus = new ServiceBus();
    $ctrl.productMap = {};
    $ctrl.config = config;

    $ctrl.creditMemoDb = new AutoQuery({
      url: 'QueryCreditMemoRequests.json',
      criteria: {
        Search: $ctrl.id,
      },
      autoLoad: true,
      onLoaded: args => $ctrl.onCreditMemoLoaded(args.first),
    });
    $ctrl.invoiceDb = new AutoQuery({
      url: 'QueryInvoices.json',
      criteria: {
        invoiceNumber: $ctrl.id,
      },
      autoLoad: false,
      onLoaded: args => $ctrl.onInvoiceLoaded(args.first),
    });
    $ctrl.productsDb = new AutoQuery({
      url: 'QueryProducts.json',
      criteria: {
        IdIn: ['IGNORE'],
      },
      autoLoad: false,
      onLoaded: args => $ctrl.onProductsLoaded(args.results),
    });

  }

  onProductsLoaded(products) {
    const $ctrl = this;
    // console.debug('onProductsLoaded', products);
    const map = products.reduce((m, p) => Object.assign(m, { [p.id]: p }), {});
    $ctrl.invoice.lines.forEach(c => c.product = map[c.productId]);
  }

  onInvoiceLoaded(invoice) {
    // console.debug('onInvoiceLoaded', invoice);
    const $ctrl = this;
    $ctrl.invoice = invoice;
    $ctrl.productsDb.criteria.IdIn = invoice.lines.map(c => c.productId);
    // console.debug('$ctrl.productsDb.criteria.IdIn', $ctrl.productsDb.criteria.IdIn);
    if ($ctrl.productsDb.criteria.IdIn.length)
      $ctrl.productsDb.load(true);
    // console.warn('$ctrl.creditMemoDb', $ctrl.creditMemoDb);
    // console.warn('isBusy', $ctrl.creditMemoDb.isBusy());
    if (invoice && !$ctrl.creditmemo) {
      $ctrl.creditmemo = cm;
      $ctrl.creditMemoDb.criteria.Search = invoice.id || invoice.invoiceNumber;
      $ctrl.creditMemoDb.load(true);
    }
    $ctrl.buildCreditLines();
  }

  onCreditMemoLoaded(cm) {
    // console.debug('onCreditMemoLoaded', cm);
    const $ctrl = this;
    if (cm) {
      $ctrl.creditmemo = cm;
      $ctrl.invoiceDb.criteria.invoiceNumber = cm.invoiceId;
    } else {
      $ctrl.invoiceDb.criteria.invoiceNumber = $ctrl.id;
    }
    $ctrl.invoiceDb.load(true);
    $ctrl.buildCreditLines();
  }

  productImage(productId, size = 'thumbnail') {
    return $appConfig.productImage(productId, size);
  }

  manageMedia(line) {
    const $ctrl = this;
    console.debug('manageMedia', line, $ctrl);
    return mediaManagerPrompt({
      realm: 'ReturnRequest',
      tagCriteria: {
        '$creditmemoId': $ctrl.creditmemo.id,
        '$invoiceLineNumber': line.invoiceLineNumber,
      },
      title: 'Credit Item Images: ' + line.productId
    });
  }

  buildCreditLines() {
    const $ctrl = this;
    if ($ctrl.creditmemo && $ctrl.invoice) {
      const byPos = _.indexBy($ctrl.creditmemo.lines, 'invoiceLineNumber');
      $ctrl.creditLines = $ctrl.invoice.lines
        .map(il => Object.assign(
          { qtyReturned: 0, quantity: 0, invoiceLineNumber: '' + il.position },
          il,
          byPos[il.position]))
        .filter(cl => cl.qtyReturned || $ctrl.creditmemo.status === 'Open');

      $ctrl.creditLines.forEach(cl => cl.quantity = cl.qtyReturned);
    }
  }

  return(line) {
    const $ctrl = this;
    line.quantity = Math.min(line.qtyShipped, 1);
    ReturnItemPrompt({
      creditmemo: $ctrl.creditmemo,
      invoice: $ctrl.invoice,
      line,
      title: 'Credit Item: ' + line.productId,
      subTitle: line.description,
    }).then(() => $ctrl.creditMemoDb.load(true));
  }

  edit() {
    const $ctrl = this;
    creditMemoPrompt({
      transitionTo: false,
      retailerId: $ctrl.invoice.retailerId,
      model: Object.assign({}, $ctrl.creditmemo)
    }).then(res => $ctrl.onEdited(res));
  }

  submit() {
    const $ctrl = this;
    creditMemoPrompt({
      commandLabel: 'Submit',
      transitionTo: 'retailer.claims.returns',
      title: `Submit Request: ${$ctrl.invoice.id}`,
      retailerId: $ctrl.invoice.retailerId,
      model: Object.assign({}, $ctrl.creditmemo, {
        status: 'Submitted',
      })
    }).then(res => $ctrl.onSubmitted(res));
  }

  onEdited() {
    const $ctrl = this;
    $ctrl.$emit('creditMemoSaved', $ctrl);
    $ctrl.creditMemoDb.load(true);
  }

  onSubmitted() {
    const $ctrl = this;
    $ctrl.$emit('creditMemoSaved', $ctrl);
    $ctrl.$state.transitionTo('retailer.returns', {
      retailerId: $ctrl.invoice.retailerId,
    });
  }

  changeQuantity(line) {
    const $ctrl = this;
    if (line.quantity > line.qtyShipped) {
      alert("Quantity cannot be greater than " + line.qtyShipped);
      line.quantity = line.qtyShipped;
      return;
    }
    if (line.id) {
      if (line.quantity > 0) {
        return $ctrl.bus.send('UpdateCreditMemoRequestLine', line).then(() => { });
      } else {
        return modals.confirm("Are you sure?", "Delete credit line").result.then(function () {
          $ctrl.bus.send('DeleteCreditMemoRequestLine', line).then(() => {
            $ctrl.credits = [];
            $ctrl.creditMemoDb.load();
          });
        });
      }
    } else {
      return $ctrl.bus.send('CreateCreditMemoRequestLine', line).then(response => {
        line.id = response.data.id;
      });
    }
  }

  incrementQty(line) {
    const $ctrl = this;
    line.quantity += 1;
    $ctrl.changeQuantity(line);
  }

  decrementQty(line) {
    const $ctrl = this;
    line.quantity -= 1;
    $ctrl.changeQuantity(line);
  }
}
